module.exports = __webpack_public_path__ + "img/icon-user-form-green.7d9c9068.svg";